import { iconMap } from "@/app/lib/iconMap";
import { fadeUp, stagger } from "@/app/lib/utils/motionVariants";
import { motion } from "framer-motion";

export default function ProductFeature({ data }: any) {
  if (!data) return null;
  return (
    <>
      <section className="relative text-[#e8eaf0] py-6 lg:py-8">

        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto px-3 text-center mb-5 lg:mb-12"
        >
          {/* <div className="inline-flex common-section-pill mb-2">{buyerChallenges?.text}</div> */}
          <h2 className="section-title !mb-2">
            {data?.title}
            <span className="section-highlight-title">{data?.titleHighlight }</span>
          </h2>
          <p className="section-description  mx-auto">{data?.subtitle}</p>
        </motion.div>

        {/* Plotter row */}
        <div className="relative">
          <div className="absolute top-1/2 right-[10%] -translate-y-1/2 w-1/2 lg:w-[500px] h-[500px] rounded-full pointer-events-none blur-3xl"
            style={{ background: 'rgba(99,102,241,0.18)' }} />
          <div className="absolute top-1/2 left-[10%] -translate-y-1/2 w-1/2 lg:w-[500px] h-[500px] rounded-full pointer-events-none blur-3xl"
            style={{ background: 'rgba(99,102,241,0.15)' }} />
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-80px' }}
            variants={stagger}
            className="relative z-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-3 lg:gap-6 mx-auto max-w-6xl"
          >

            {data?.items?.length ? data.items.map((it: any,i:number) => {
              const LucideIcon =
                iconMap[
                it.icon as keyof typeof iconMap
                ] as React.ElementType;

              const Icon = LucideIcon || iconMap.Home;
              return (
                <motion.div
                  key={it.id}
                  variants={fadeUp}
                  className="relative overflow-hidden group rounded-2xl p-6 bg-white/[0.04] backdrop-blur-xl border border-white/10 shadow-xl lg:border-r lg:border-white/10"
              >
                <div className='absolute top-0 right-0 group-hover:w-full group-hover:h-full  w-32 h-32 bg-cyan-500/5 rounded-full blur-2xl -mr-10 -mt-10 transition-all group-hover:bg-cyan-500/15 z-[-1]'></div>
                <div className="w-14 h-14 mb-5 rounded-xl bg-gradient-to-br from-cyan-400/20 via-blue-500/20 to-indigo-600/20 flex items-center justify-center shadow-[0_0_24px_rgba(#000c1e)] border border-cyan-500/30">
                  <Icon className="w-6 h-6 text-white" />
                </div>
                <div className="relative inline-block overflow-hidden">
                  <h3 className="text-base md:text-lg font-semibold text-white">{it.title}</h3>
                </div>
                <div className=" text-white/70 text-sm tracking-[0.6px]">{it.subtitle ?? it.description}</div>
              </motion.div>
             )
            }) : null}
          </motion.div>
        </div>

      </section>
    </>
  );
}
